import { render, staticRenderFns } from "./RecentWinner.vue?vue&type=template&id=473d226c&"
import script from "./RecentWinner.vue?vue&type=script&lang=js&"
export * from "./RecentWinner.vue?vue&type=script&lang=js&"
import style0 from "./RecentWinner.vue?vue&type=style&index=0&id=473d226c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
